import { CampaignLifecycleType } from 'src/common/interfaces/campaigns';
import { useGetCampaignsQuery } from 'src/features/campaigns/campaigns.slice';
import { INVITE_LOCAL_STORAGE_KEY } from '../invite-page';

export const useShouldShowInviteElement = (username?: string) => {
  const { data: campaignsResponse } = useGetCampaignsQuery();

  const activeCampaigns = campaignsResponse?.data;

  const flashSale = activeCampaigns?.find((campaign) => campaign.lifecycleType === CampaignLifecycleType.TIME_BASED);
  const hasActiveFlashSale =
    flashSale?.startDate &&
    flashSale?.endDate &&
    Date.now() >= new Date(flashSale.startDate).getTime() &&
    Date.now() < new Date(flashSale.endDate).getTime();
  const inviterUsername = localStorage.getItem(INVITE_LOCAL_STORAGE_KEY);
  const isInviterSelf = username === inviterUsername;

  return {
    shouldShowElement: !hasActiveFlashSale && !!inviterUsername && !isInviterSelf,
  };
};
